export const en = {
    colours: 'colours',
    tastes: 'tastes',
    sizes: 'sizes',
    frequency: 'frequency',
    addedToBag: 'Added to bag',
    addToBag: 'Add to bag',
    selectSize: 'Select size',
    selectStyle: 'Select style',
    optionsAvailable: 'Options available',
    selectSizeAndStyle: 'Select size & style',
    oneTimeShipment: '1 Time Shipment',
    autoDelivery: 'Auto Delivery',
    size: 'Size',
    viewAllSizes: 'View all sizes',
    viewAll: 'View all',
    was: 'Was',
    reviews: 'reviews',
    by: 'By',
    goToDetailPage: 'Go to detail page',
};

export const fr = {
    colours: 'colours',
    tastes: 'tastes',
    sizes: 'sizes',
    frequency: 'frequency',
    addedToBag: 'Added to bag',
    addToBag: 'Add to bag',
    selectSize: 'Select size',
    selectStyle: 'Select style',
    optionsAvailable: 'Options available',
    selectSizeAndStyle: 'Select size & style',
    oneTimeShipment: '1 Time Shipment',
    autoDelivery: 'Auto Delivery',
    size: 'Size',
    viewAllSizes: 'View all sizes',
    viewAll: 'View all',
    was: 'Was',
    reviews: 'reviews',
    by: 'By',
    goToDetailPage: 'Go to detail page',
};
